import { useTranslation } from 'react-i18next';

import { useCoBranding } from './useCoBranding';

import type { CoverageKey } from '../models/coverage';
import type { FeeType } from '@insify/funnel-components';
import type React from 'react';

export const useFeeTranslations = (): Record<
  FeeType,
  {
    title: React.ReactNode;
    description: React.ReactNode;
  }
> => {
  const { t } = useTranslation(['funnel']);
  const { branding } = useCoBranding();

  return {
    distributionFee: {
      title: t('funnel:receipt_distribution_fee'),
      description: t('funnel:receipt_distribution_fee_description', {
        partnerName: branding?.name,
      }),
    },

    extraMonthsPayable: {
      title: t('funnel:receipt_extra_months_payable'),
      description: t('funnel:receipt_extra_months_payable_description'),
    },
  };
};

export const usePriceBreakdownTranslations = (): Record<
  FeeType | Exclude<CoverageKey, 'legalProtection' | 'carInsurance'>,
  {
    title: React.ReactNode;
    description: React.ReactNode;
  }
> => {
  const { t } = useTranslation(['funnel']);
  const feeTranslations = useFeeTranslations();

  return {
    ...feeTranslations,

    professionalLiability: {
      title: t('funnel:receipt_extra_months_payable'),
      description: t('funnel:receipt_extra_months_payable_description'),
    },

    publicLiability: {
      title: t('funnel:receipt_extra_months_payable'),
      description: t('funnel:receipt_extra_months_payable_description'),
    },

    propertyMultiRisk: {
      title: t('funnel:receipt_extra_months_payable'),
      description: t('funnel:receipt_extra_months_payable_description'),
    },
  };
};
